import faker from '@faker-js/faker';
import loopMap from 'mn-utils/loopMap';
import {TListItem} from './types';

export const getTransactionsList = (limit: number): TListItem[] => {
  return loopMap(limit, () => {
    return getTransactionDetails();
  });
};

export const getTransactionDetails = (): TListItem => {
  const payoutMethod = ['card'];
  const paymentStatuses = ['initiated', 'pending', 'paid', 'paid'];
  return {
    id: faker.datatype.uuid(),
    date: faker.date.recent().toISOString(),
    retailer: faker.name.findName(),
    customer_mail: faker.internet.email(),
    payout_method: (faker.helpers as any).arrayElement(payoutMethod),
    fiat_amount: faker.finance.amount(1000, 10000, 2),
    fiat_code: faker.finance.currencyCode(),
    crypto_amount: faker.finance.amount(1000, 10000, 2),
    swift_code: faker.finance.currencyCode(),
    fee_code: faker.finance.currencyCode(),
    fee_pg: faker.finance.amount(1000, 10000, 2),
    fee_lunu_pg: faker.finance.amount(1000, 10000, 2),
    fee_lunu_ret: faker.finance.amount(1000, 10000, 2),
    hash: faker.datatype.hexadecimal(20),
    status: (faker.helpers as any).arrayElement(paymentStatuses),
  } as TListItem;
};
